import type { SiteSettings } from '@/lib/types/siteSettings';

export interface ContactHourEntry {
  label: string;
  value: string;
}

export interface LeadershipContactEntry {
  name: string;
  title?: string;
}

export interface ContactInfo {
  addressLines: string[];
  phone: string;
  email: string;
  hours: ContactHourEntry[];
  contacts: LeadershipContactEntry[];
  mapEmbedUrl: string;
}

export const DEFAULT_CONTACT_INFO: ContactInfo = {
  addressLines: ['501 Alliance Ave, Unit 401', 'Toronto, ON M6N 2J1'],
  phone: '(416) 504-0077',
  email: 'info@strashindevelopments.com',
  hours: [
    { label: 'Monday-Friday', value: '9:00 AM - 5:00 PM' },
    { label: 'Weekends', value: 'By appointment' },
  ],
  contacts: [
    { name: 'Dr. Elliot Strashin', title: 'President' },
    { name: 'Daniel Glick', title: 'Property Manager' },
    { name: 'Irene Vance', title: 'Controller' },
  ],
  mapEmbedUrl:
    'https://www.google.com/maps?q=501+Alliance+Ave+Unit+401+Toronto+ON+M6N+2J1&output=embed',
};

export function buildContactInfo(siteSettings: SiteSettings | null | undefined): ContactInfo {
  if (!siteSettings) {
    return DEFAULT_CONTACT_INFO;
  }

  const addressLines =
    siteSettings.contactAddressLines.length > 0
      ? siteSettings.contactAddressLines
      : DEFAULT_CONTACT_INFO.addressLines;
  const phone = siteSettings.contactPhone.trim().length > 0 ? siteSettings.contactPhone : '';
  const email = siteSettings.contactEmail.trim().length > 0 ? siteSettings.contactEmail : '';
  const hours =
    siteSettings.contactHours.length > 0 ? siteSettings.contactHours : DEFAULT_CONTACT_INFO.hours;
  const contacts =
    siteSettings.leadershipContacts.length > 0
      ? siteSettings.leadershipContacts.map((entry) => ({
          name: entry.name,
          title: entry.title ?? undefined,
        }))
      : DEFAULT_CONTACT_INFO.contacts;
  const mapEmbedUrl = siteSettings.mapEmbedUrl.trim().length > 0 ? siteSettings.mapEmbedUrl : '';

  return {
    addressLines,
    phone: phone.length > 0 ? phone : DEFAULT_CONTACT_INFO.phone,
    email: email.length > 0 ? email : DEFAULT_CONTACT_INFO.email,
    hours,
    contacts,
    mapEmbedUrl: mapEmbedUrl.length > 0 ? mapEmbedUrl : DEFAULT_CONTACT_INFO.mapEmbedUrl,
  };
}
